import { useEffect, useState, useMemo } from "react";
import { PlusCircleOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Spin, Modal, Button, Dropdown } from "antd";
import TableComponent from "../../components/TableComponent";
import { createColumn } from "../../utils/tableUtils";
import { useNavigate } from "react-router-dom";
import { tableDateFormatter } from "../../utils/formatDate";
import MainButtonComponent from "../../components/MainButtonComponent";
import {
	HeaderComponent,
	Container,
	ContainerHeader,
	ActionButtonComponent,
	StatusCell
} from "./styles";
import { useBannerMobileContext } from "../../context/BannerMobileContext/BannerMobileContext";

const BannerMobileList: React.FC = () => {
	const [tableData, setTableData] = useState<any[]>([]);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [currentItem, setCurrentItem] = useState<any>(null);
	const { bannerMobileList, removeBannerMobile, getBannerMobileList, operationStatus } = useBannerMobileContext();

	const navigate = useNavigate();

	useEffect(() => {
		getBannerMobileList();
	}, []);

	useEffect(() => {
		setTableData(bannerMobileList);
	}, [bannerMobileList]);

	const columns = useMemo(() => [
		createColumn({
			title: "Sıra No",
			dataIndex: "displayOrder",
			width: 20,
			sorterType: "numeric"
		}),
		createColumn({
			title: "Başlık",
			dataIndex: "firstHeader",
			width: 40,
			sorterType: "string",
		}),
		createColumn({
			title: "Menü Bağlantısı",
			dataIndex: "hasMenu",
			width: 35,
			sorterType: "boolean",
			render: (text, record) => (
				<StatusCell $hasMenu={record.hasMenu}>{record.hasMenu ? "Var" : "Yok"}</StatusCell>
			),
		}),
		createColumn({
			title: "Aktif mi?",
			dataIndex: "isActive",
			width: 35,
			sorterType: "boolean",
			render: (text, record) => (
				<StatusCell $hasMenu={record.isActive}>{record.isActive ? "Aktif" : "Pasif"}</StatusCell>
			),
		}),
		createColumn({
			title: "Tarih",
			dataIndex: "creationDate",
			width: 30,
			sorterType: "string",
			render: (text) => tableDateFormatter(text, "DD.MM.YYYY"),
		}),
		createColumn({
			title: "",
			dataIndex: "action",
			width: 20,
			render: (text, record: any) => {
				const menuItems = [
					{
						key: "edit",
						label: "Güncelle",
						onClick: () => navigate(`/edit-mobile-banner/${record.bannerId}`),
					},
					{
						key: "delete",
						label: "Sil",
						onClick: () => {
							setCurrentItem(record);
							setIsModalVisible(true);
						},
					},
				];

				return (
					<Dropdown menu={{ items: menuItems }} trigger={["click"]}>
						<MoreOutlined />
					</Dropdown>
				);
			},
		}),
	], [tableData]);

	return (
		<div>
			<HeaderComponent>Mobil Banner</HeaderComponent>
			<Container>
				<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
					<ContainerHeader>
						<ActionButtonComponent>
							<MainButtonComponent
								style={{ marginRight: "15px" }}
								icon={<EditOutlined />}
								onClick={() => navigate("/order-mobile-banners")}
							>
								Sırala
							</MainButtonComponent>
						</ActionButtonComponent>
						<ActionButtonComponent>
							<MainButtonComponent
								style={{ marginRight: "15px" }}
								icon={<PlusCircleOutlined />}
								onClick={() => navigate("/add-mobile-banner")}
							>
								Yeni Ekle
							</MainButtonComponent>
						</ActionButtonComponent>
					</ContainerHeader>
				</Spin>
				{!(operationStatus.type === "loading" && operationStatus.operation === "fetch") && (
					<TableComponent
						columns={columns}
						dataSource={tableData}
					/>
				)}
			</Container>
			<Modal
				title="Mobil Banner'ı Sil"
				open={isModalVisible}
				onCancel={() => setIsModalVisible(false)}
				footer={[
					<Button key="back" type="text" onClick={() => setIsModalVisible(false)}>
						İptal
					</Button>,
					<Button
						loading={operationStatus.type === "loading" && operationStatus.operation === "delete"}
						key="submit"
						type="primary"
						danger
						onClick={async () => {
							await removeBannerMobile(currentItem?.bannerId);
							setIsModalVisible(false);
						}}
					>
						Evet
					</Button>,
				]}
			>
				<p><strong>{`"${currentItem?.firstHeader}"`}</strong> bannerını silmek istediğinizden emin misiniz?</p>
			</Modal>
		</div>
	);
};

export default BannerMobileList;
